var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79298 6.82231C5.41221 7.27462 6.17683 7.53846 7.00068 7.53846C9.0156 7.53846 10.7699 5.79438 10.7699 3.76923C10.7699 1.69077 9.07914 0 7.00068 0C4.92221 0 3.23145 1.69077 3.23145 3.76923C3.23145 5.02385 3.84529 6.13846 4.79298 6.82231Z",
    fill: "#A94881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3169 7.2959C9.45 8.11436 8.28154 8.61513 7 8.61513C5.71846 8.61513 4.55 8.11436 3.68308 7.2959C1.49154 8.48051 0 10.8013 0 13.4613C0 13.7574 0.242308 13.9997 0.538462 13.9997H13.4615C13.7577 13.9997 14 13.7574 14 13.4613C14 10.8013 12.5085 8.48051 10.3169 7.2959Z",
    fill: "#A94881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assign-icon.5a39222f.svg";
export { ForwardRef as ReactComponent };